<template>
  <span class="rotulo d-inline-block p-1 m-1" :class="corRotulo">
    <slot>{{ rotulo }}</slot>
  </span>
</template>

<script>
export default {
  name: "Rotulo",
  props: {
    rotulo: {
      type: String,
      required: false
    },
    cor: {
      type: [Number, String],
      default: 0
    }
  },
  computed: {
    corRotulo() {
      return `rotulo-${this.cor}`;
    }
  }
};
</script>
